
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaigns/bootcamp",
      function () {
        return require("private-next-pages/campaigns/bootcamp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaigns/bootcamp"])
      });
    }
  